import {PaywallPage} from "../../PaywallPage";

export class PanelCollapsed extends PaywallPage {
    widthValue = 420;
    heightValue = 380;
}
